/* ════════════════════════════════════════════════════════════
   section-footer.js
   Mobile accordion behavior for footer menu blocks.
   Toggles .is-open class on .footer-block--menu when summary
   button is clicked under 750px. Desktop is no-op (CSS keeps
   panel always visible there).
   ════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  function initFooterAccordion(root) {
    var scope = root || document;
    var toggles = scope.querySelectorAll('.footer-block--menu .footer-block__toggle');

    toggles.forEach(function (toggle) {
      if (toggle.dataset.faInit === '1') return;
      toggle.dataset.faInit = '1';

      toggle.addEventListener('click', function (e) {
        // Desktop: do nothing — CSS keeps the panel visible
        if (window.matchMedia('(min-width: 750px)').matches) return;

        var block = toggle.closest('.footer-block--menu');
        if (!block) return;

        var isOpen = block.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFooterAccordion();
    });
  } else {
    initFooterAccordion();
  }

  // Re-initialize when Shopify reloads the section in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.footer-block--menu')) {
      initFooterAccordion(e.target);
    }
  });

  // If viewport resizes from mobile to desktop, ensure all panels are visible
  // (clear any leftover .is-open state so behavior is consistent).
  // We don't auto-close on resize back to mobile — let user re-open if needed.
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (window.matchMedia('(min-width: 750px)').matches) {
        document.querySelectorAll('.footer-block--menu.is-open').forEach(function (block) {
          var toggle = block.querySelector('.footer-block__toggle');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
          block.classList.remove('is-open');
        });
      }
    }, 150);
  });
})();